import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { useAnalytics } from 'use-analytics';
import { TravelTypes } from '../constants';
import useBrochureOptionRemoval from './useBrochureOptionRemoval';
import getBrochureTripId from '../helpers/getBrochureTripId';
import { addToBrochure } from '../store/slices/brochure';

const useHandleTourAddToBrochure = ({
  tripId,
  tourItinerary,
  brochure,
  isViewingBrochure,
  isBrochurePage,
  currentBrochure,
  brochureOnBrochurePage,
}) => {
  const { staterooms } = useSelector((store) => store.tripSearch.searchObj);
  const id = getBrochureTripId(tripId, brochure, tourItinerary, staterooms, TravelTypes.tour);

  const findTourItineraryByKey = (tripSegments, uniqueKey) =>
    _.find(tripSegments, (ts) => ts.itinerary.uniqueKey === uniqueKey);

  const dispatch = useDispatch();
  const { track } = useAnalytics();
  const handleSegmentRemoval = useBrochureOptionRemoval();

  const handleAddToBrochureClick = (event) => {
    if (event && event.type === 'keydown' && event.key !== 'Enter') return;
    if (!tourItinerary) return;

    const handleSegmentRemovalWrapper = (brochureId, brochureToUpdate, isSavedToDatabase) => {
      handleSegmentRemoval({
        brochureId,
        currentBrochure: brochureToUpdate,
        travelType: TravelTypes.tour,
        segmentKey: 'uniqueKey',
        segmentKeyValue: tourItinerary.uniqueKey,
        findTripSegmentfn: findTourItineraryByKey,
        isSavedToDatabase,
        itinerary: tourItinerary,
        staterooms,
      });
    };

    if (isBrochurePage && brochureOnBrochurePage && tripId) {
      const brochureToUpdate = JSON.parse(JSON.stringify(brochureOnBrochurePage));
      handleSegmentRemovalWrapper(tripId, brochureToUpdate, true);
      return;
    }

    if (isViewingBrochure && !_.isNil(currentBrochure)) {
      handleSegmentRemovalWrapper(brochure?.id, currentBrochure, brochure?.isSavedToDatabase);
    }

    let updatedTrip = { tripSegments: [] };
    if (brochure && brochure.trips && brochure.trips[id]) {
      updatedTrip = JSON.parse(JSON.stringify(brochure.trips[id]));
    }

    let action = 'add';
    const tripSegment = findTourItineraryByKey(updatedTrip.tripSegments, tourItinerary.uniqueKey);
    if (!tripSegment) {
      updatedTrip.tripSegments.push({ itinerary: { ...tourItinerary } });
    } else {
      _.remove(
        updatedTrip.tripSegments,
        (ts) => ts.itinerary.uniqueKey === tripSegment.itinerary.uniqueKey,
      );
      action = 'remove';
    }

    dispatch(
      addToBrochure({
        tripId: id,
        updatedTrip,
        staterooms,
      }),
    );
    track(`TourBrochure.${action}`, { tourKey: tourItinerary?.uniqueKey });
  };

  return handleAddToBrochureClick;
};

export default useHandleTourAddToBrochure;
